import { onMounted, onUnmounted, ref } from 'vue';
export function useClickOutside(targetRef, callback) {
    const isDropdownOpen = ref(false);
    const handleClickOutside = (event) => {
        const target = event.target;
        if (targetRef.value && !targetRef.value.contains(target) && !target.classList.contains('no-click')) {
            isDropdownOpen.value = false;
            callback();
        }
    };
    onMounted(() => {
        document.body.addEventListener('click', handleClickOutside);
    });
    onUnmounted(() => {
        document.body.removeEventListener('click', handleClickOutside);
    });
    return { isDropdownOpen };
}
